import React, { Component } from 'react'
import TextField from 'material-ui/TextField';
import { connect } from 'react-redux'
import { api } from "../../../../../../api/index"
import {loadImages, resetImages} from "../../../../../../api/images";


class PromotionGeneralMiniAdComponent extends Component {
	constructor(props) {
		super(props);

		this.handlePositionFieldState = this.handlePositionFieldState.bind(this);
	}

	handlePositionFieldState(event) {

		const target = event.target;
		const name = target.name;
		const value = target.value;

		api.promotions.handlePositionFieldState( name, value, this.props.periodKey, this.props.variantKey );
	}

	render() {
		return (
			<div className="grid-x grid-margin-y grid-margin-x">
				<div className="medium-12 cell">

				</div>
			</div>
		);
	}
}

const mapStateToProps = ( state ) => {
	return {
		promotion: state.promotion
	}
}

export default connect(mapStateToProps, {
	loadImages,
	resetImages
})(PromotionGeneralMiniAdComponent)


// WEBPACK FOOTER //
// ./src/application/components/promotions/components/types/general/shout.js